var render = function render(_c,_vm){return _c('h1',_vm._b({class:[_vm.data.class, _vm.data.staticClass, { 'small': _vm.props.isSmall }],style:([_vm.data.style, _vm.data.staticStyle])},'h1',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }